import { NgModule } from '@angular/core';
import { CompanyActions } from '@company/data-access';
import { EffectsModule } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { MODULE_INITIALIZER } from '@spartacus/core';
import { effects } from './effects';
import { CompanyLazyService, CompanyService } from './services';

function initFeatureFactory(store: Store): () => void {
  return () => {
    store.dispatch(new CompanyActions.InitializeCompanyFeature());
  };
}

@NgModule({
  imports: [EffectsModule.forFeature(effects)],
  providers: [
    CompanyLazyService,
    {
      provide: CompanyService,
      useExisting: CompanyLazyService,
    },
    {
      provide: MODULE_INITIALIZER,
      useFactory: initFeatureFactory,
      deps: [Store],
      multi: true,
    },
  ],
})
export class CompanyFeatureModule {}
